import React from 'react'
import ImportData from "./ImportData";
import SarasMsg from '../../../library/notifications/SarasMsg'
import SarasTrans from '../../../library/notifications/SarasTrans';
import {getFormRow, getFormRowVal} from '../../cmn/docAutomation/formFunctions';
import { ioRequest } from "./inputOuputFunctions";
import SarasModal from '../../../library/container/popup/SarasModal';
import {UiView} from "../../../library/layout/Index";
import SarasDialog from '../../../library/container/popup/SarasDialogDefAction';

const ImportShorthand = (props) => {
    const { importTpl, onPopupClose } = props;
    const [viewData, setViewData] = React.useState(null);
    const [fileDetail, setFileDetail] = React.useState({});
    const [formNotifications,setFormNotifications] = React.useState(null);
    const [open, setOpen] = React.useState(true);

    
    const onTemplateSelect = (event, valObj) => {
        let customAction = { actionId: "show", sview: "upload", tplChange: 1, tplScreen: "ImportRequestor", tplKey: importTpl, viewDataKey: "importData" }
        console.log("Import ImportSH", customAction);
        ioRequest("coreImport", customAction, onSuccess)
    }

    React.useEffect(onTemplateSelect, [importTpl]);

    const sendImportRequest = () => {
        let action = { actionName: "coreImport", actionId: "print", tplScreen: "ImportRequestor", tplKey: importTpl };
        if (fileDetail) {
            action["tplDataFile"] = fileDetail.filename;
            action["tplDataFileO"] = fileDetail.ofilename;
        }

        ioRequest("coreImport", action, onSuccess)
    }

    const onSuccess = (action, response) => {
        setFormNotifications({msgType:response.data.isError, msg:response.data.msg, messageList:response.data.messageList || {}});
        console.log("Import onSuccess", {msgType:response.data.isError, msg:response.data.msg, messageList:response.data.messageList || {}});
        if(action.actionId === "show")
        {
            setViewData(response.data.mainViewData);
        }
        else if(action.actionId === "print")
        {
            setTimeout(closePopup,3000);
        }
    }

    const onFileUpload = (fileDetail) => {
        setFileDetail(fileDetail)
    }

    const closePopup = () => {
        console.log("Import closePopup")
        if(onPopupClose)onPopupClose();
        setOpen(false);
    }

    console.log("Import Open", open)

    if (!viewData)
        return (null)

    const templateDtlRow = getFormRow(viewData.viewRows, "0");
    const templateDtlRowValue = getFormRowVal(templateDtlRow, "importTemplateFile")

    return (
        <>
        <SarasMsg notification={formNotifications} />
        <SarasModal enableModal={open} modelState={open} >
            <SarasDialog formStyle={{ width: '500px' }} title='Import Data'
                actionName='Import' actionFunction={sendImportRequest} cancelName='Cancel' cancelFunction={closePopup} >
            <UiView>
                <div className="uiSearchHead">
                    <div className="phSectionCriteria uiSpacer20 uiSpacerUD10">
                        <div className="uiSpacerH15">
                            <span className="uiLbl"><SarasTrans value="Template Name" /></span>
                            <span className="uiVal">{templateDtlRowValue.valF}</span>
                        </div>
                        <div className="uiInvSearchHeader">
                            <ImportData viewData={viewData} onFileUpload={onFileUpload} />
                        </div>
                    </div>
                </div>
            </UiView >
            </SarasDialog>
        </SarasModal>
        </>
    )
}

export default ImportShorthand;